import React from "react";
import { Link, Route, Switch } from "react-router-dom";
import SuppliersList from "./SuppliersList";
import SuppliersForm from "./SuppliersForm";
import Content from "../../../_psb/layout/Content";
import SubHeader from "../../../_psb/layout/sub-header/SubHeader";
import Search from "../../../components/form/Search";
import { connect } from "react-redux";
import { setSearchValueAction } from "../../../modules/suppliers/Actions";
import { searchValueSelector } from "../../../modules/suppliers/Selectors";
import getLangData from "../../../utils/getLangData";

const suppliers = (props) => {
	const { searchValue, setSearchValue } = props;
	return (
		<>
			<SubHeader
				title="Suppliers"
				Component={() => (
					<>
						<Switch>
							<Route
								exact
								path="/suppliers"
								component={() => {
									return (
										<>
											<span className="kt-subheader__separator kt-subheader__separator--v"></span>
											<Search
												searchValue={searchValue}
												setSearchValue={setSearchValue}
											/>
										</>
									);
								}}
							/>
						</Switch>
					</>
				)}
			>
				<Switch>
					<Route
						exact
						path="/suppliers"
						component={() => (
							<Link to="/suppliers/create" className="btn btn-primary">
								Add New{" "}
							</Link>
						)}
					/>

					<Route
						exact
						path={["/suppliers/create", "/suppliers/:id"]}
						component={() => {
							return (
								<Link to="/suppliers" className="btn-label-brand btn btn-bold">
									{getLangData().general_words.back_to_list}
								</Link>
							);
						}}
					/>
				</Switch>
			</SubHeader>
			<Content>
				<Switch>
					<Route exact path="/suppliers" component={SuppliersList} />
					<Route exact path="/suppliers/create" component={SuppliersForm} />
					<Route exact path="/suppliers/:id" component={SuppliersForm} />
				</Switch>
			</Content>
		</>
	);
};

const mapStateToProps = (state) => ({
	searchValue: searchValueSelector(state),
});

const mapDispatchToProps = {
	setSearchValue: setSearchValueAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(suppliers);
